import moment from 'moment';

const BASE_DATE_FORMAT = 'DD/MM/YYYY'
const BASE_DATETIME_FORMAT = 'DD/MM/YYYY, HH:MM'

export function formatDateToBaseFormat(date, includeTime) {
    const momentDate = moment(date);

    return includeTime 
        ? momentDate.format(BASE_DATETIME_FORMAT)
        : momentDate.format(BASE_DATE_FORMAT);
}

function getCurrentUTCTime() {
    // Fallback using UTC time adjustment
    const now = new Date();
    const utcHours = now.getUTCHours();
    const utcMinutes = now.getUTCMinutes();
    const monthNumber = now.getMonth() + 1; // Months start from 0 (Jan)
    // DST starts last Sunday of March & ends last Sunday of October
    const isDST = monthNumber >= 4 && monthNumber <= 10;
    const belgiumOffset = isDST ? 2 : 1;
    const uHours = utcHours + belgiumOffset;
    const uMinutes = utcMinutes;
    return { uHours, uMinutes };
}

function getCurrentBelgiumTime() {
    let hours = 0;
    let minutes = 0;
    try {
        // Get Belgium time dynamically (handles DST automatically)
        const belgiumTime = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Europe/Brussels',
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: 'h23',
        }).format(new Date());

        const timeParts = belgiumTime.split(':').map(Number);

        if (timeParts.length === 2) {
            hours = timeParts[0];
            minutes = timeParts[1];
        } else {
            const { uHours, uMinutes } = getCurrentUTCTime();
            hours = uHours;
            minutes = uMinutes;
        }
    } catch (error) {
        const { uHours, uMinutes } = getCurrentUTCTime();
        hours = uHours;
        minutes = uMinutes;
    }
    return { hours, minutes };
}

export function isWorkingHours() {
    const { hours } = getCurrentBelgiumTime();
    return hours >= 8 && hours < 18;
}
